import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Button, Card } from '../../ui-blocks'

import { ImageSelector } from './ImageSelector'
import { VideoSelector } from './VideoSelector'

import { mediaElementPropTypes } from './media-element'


const isUsingVideo = mediaType => mediaType === 'YouTube'


export const MediaSelector = ({ media, setMedia }) => {
  const [showUseVideo, setShowUseVideo] = useState(isUsingVideo(media?.type))

  useEffect(() => {
    setShowUseVideo(isUsingVideo(media?.type))
  }, [media])

  const imageSelectorLabel = (showUseVideo || !media) ? 'Use an image' : 'Replace image'


  return (
    <Card title="Featured media" imageProps={media?.previewUrl ? {
      src: media?.previewUrl,
      alt: 'Featured media'
    } : {}}>
      <div className="d-flex flex-wrap gap-2">
        <ImageSelector
          setMedia={setMedia}
          trigger={(<Button variant="secondary" className="btn-sm px-3">
            {imageSelectorLabel}
          </Button>)}
        />
        {!showUseVideo && (
          <Button variant="secondary" className="btn-sm px-3" onClick={() => setShowUseVideo(true)}>
            Use a YouTube video
          </Button>
        )}
      </div>
      {showUseVideo && (
        <div className="mt-3">
          <VideoSelector media={media} setMedia={setMedia} />
        </div>
      )}
    </Card>
  )
}


MediaSelector.propTypes = {
  media: mediaElementPropTypes,
  setMedia: PropTypes.func.isRequired
}
